import { useTranslation } from "react-i18next"
import NotificationBell from "./NotificationBell";
const Header = ({
  showAuthButtons = false,
  customButtons = null,
  containerStyle = {}
}) => {
  const navigate = (path) => {
    // In your actual app, this would use react-router-dom's useNavigate
  }
  const { t, i18n } = useTranslation()

  // Check if user is authenticated
  const isAuthenticated = localStorage.getItem('access_token') && localStorage.getItem('user_data');

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang)
  }
  const handleLanguageToggle = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
    handleLanguageChange(newLang);
  }

  // Check if we're on a registration page (in real app, use useLocation)
  const isRegistrationPage = window.location.pathname?.includes('/auth/register') ||
    window.location.pathname?.includes('/complete-profile') ||
    window.location.pathname?.includes('/create-password')

  const defaultHeaderStyle = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0 60px',
    zIndex: 10,
    boxSizing: 'border-box',
    fontFamily: '"Red Hat Display", sans-serif',
    ...containerStyle
  }

  const logoStyle = {
    width: '230px',
    height: '90px',
    backgroundImage: 'url(/icons/navbar/Sulhafa_Beta_Logo.png)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    cursor: 'pointer'
  }

  const buttonContainerStyle = {
    display: 'flex',
    gap: '16px'
  }

  const loginButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 24px',
    border: '2px solid #E5E7EB',
    borderRadius: '12px',
    background: '#FFFFFF',
    color: '#374151',
    fontFamily: '"Red Hat Display", sans-serif',
    fontWeight: 600,
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textDecoration: 'none'
  }

  const getStartedButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 24px',
    border: 'none',
    borderRadius: '12px',
    background: '#3B82F6',
    color: '#FFFFFF',
    fontFamily: '"Red Hat Display", sans-serif',
    fontWeight: 600,
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
    textDecoration: 'none'
  }

  // Language and Help section for registration page
  const LanguageHelpSection = () => (
    <div style={{
      display: 'flex',
      gap: '40px',
      alignItems: 'center'
    }}>
      {/* Language Selector */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        cursor: 'pointer'
      }}>

        <button
          onClick={handleLanguageToggle}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
            background: "none",
            border: "none",
            padding: 0,
            fontFamily: '"Red Hat Display", sans-serif',
            fontWeight: 600,
            fontSize: "20px",
            color: "#303E4E",
          }}
          aria-label={t('header.toggleLanguageAria')}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#4B5768" strokeWidth="2" />
            <path
              d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
              stroke="#4B5768"
              strokeWidth="2"
            />
          </svg>

          <span
            style={{
              fontFamily: '"Red Hat Display", sans-serif',
              fontWeight: 600,
              fontSize: "20px",
              color: "#303E4E",
            }}
          >
            {i18n.language === 'en' ? 'EN' : 'AR'}
          </span>
        </button>



      </div>

      {/* Help Icon */}
      <div style={{
        width: '24px',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer'
      }}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" fill="#4B5768" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12 17h.01" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  )

  return (
    <header style={defaultHeaderStyle}>
      <div
        style={logoStyle}
        onClick={() => navigate('/')}
      ></div>

      {/* Right side content container */}
      <div style={{
        position: 'absolute',
        right: '60px',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
      }}>

        {/* Show language/help on registration page */}
        {isRegistrationPage && <LanguageHelpSection />}

        {/* Show notification bell if authenticated */}
        {isAuthenticated && !isRegistrationPage && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <NotificationBell />
          </div>
        )}

        {/* Show auth buttons on other pages */}
        {showAuthButtons && !isRegistrationPage && !isAuthenticated && (
          <div style={buttonContainerStyle}>
            <button
              onClick={() => navigate('/auth/login')}
              style={loginButtonStyle}
              onMouseEnter={(e) => {
                e.target.style.borderColor = '#D1D5DB'
                e.target.style.background = '#F9FAFB'
              }}
              onMouseLeave={(e) => {
                e.target.style.borderColor = '#E5E7EB'
                e.target.style.background = '#FFFFFF'
              }}
            >
              {t('header.login')}
            </button>
            <button
              onClick={() => navigate('/auth/select-type')}
              style={getStartedButtonStyle}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-1px)'
                e.target.style.boxShadow = '0 6px 20px rgba(59, 130, 246, 0.4)'
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)'
                e.target.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)'
              }}
            >
              {t('header.getStarted')}
            </button>
          </div>
        )}

        {/* Custom buttons if provided */}
        {customButtons && !isRegistrationPage && customButtons}
      </div>
    </header>
  )
}

export default Header